import React from 'react';
import { useTranslation } from 'react-i18next';
import DataTable from '../../../shared/components/tables/DataTable';
import DataPreviewSkeleton from '../../../shared/components/feedback/DataPreviewSkeleton';

interface DataPreviewSectionProps {
  tableData: string[][];
  processedTableData: string[][];
  isLoading?: boolean;
}

const DataPreviewSection: React.FC<DataPreviewSectionProps> = ({
  tableData,
  processedTableData,
  isLoading = false
}) => {
  const { t } = useTranslation('dataUpload');

  return (
    <>
      {/* Show skeleton while loading */}
      {isLoading && <DataPreviewSkeleton />}
      
      {/* Raw Data Preview */}
      {!isLoading && tableData.length > 0 && (
        <div className="table-container">
          <h2 className="table-title">{t('previewTitle')}</h2>
          <div className="table-wrapper">
            <DataTable tableData={tableData} />
          </div>
        </div>
      )}

      {/* Processed Data Table - only shown when processing is complete */}
      {processedTableData.length > 0 && (
        <div className="table-container processed-data-container bg-green-50 border border-green-200 rounded-lg p-4">
          <h2 className="table-title text-green-700">{t('processedDataTable')}</h2>
          <div className="table-wrapper">
            <DataTable
              tableData={processedTableData}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DataPreviewSection;